import * as React from 'react';
import Auth from '@aws-amplify/auth';


const initialUserState = {
	user: null,
	groups: null,
	permissions: {
		isAdmin: false,
		isAreaTeam: false,
		isInvitado: false
	},
	loading: true
};

export const GlobalContext = React.createContext({
	userState: initialUserState,
	checkUser: () => { },
	signOut: () => { },
	session: () => { },
	// notifications: [],
	// notify: (action: NotificationAction) => { }
});


export type NotificationObject = {
	message: String;
}

const initialNotificationsState: Array<NotificationObject> = [];

export const GlobalState = (props: any) => {

	// USER STATE GLOBAL CONTEXT
	const [userState, dispatch] = React.useReducer(reducer, initialUserState);
	function reducer(state: any, action: any) {
		switch (action.type) {
			case 'setUser':
				// console.log('SETUSER', action.user);
				return { ...state, user: action.user, loading: false };
			case 'loaded':
				return { ...state, loading: false };
			default:
				return state;
		}
	}
	function getSession() {
		return Auth.currentSession()
			.then(session => {
				return session;
			})
			.catch(error => {
				console.error("Error obteniendo sesión:", error);
				throw error;
			});
	}

	async function checkUser() {
		try {
			const userCurrentAuthenticatedUser = await Auth.currentAuthenticatedUser();
			dispatch({ type: 'setUser', user: userCurrentAuthenticatedUser });
		} catch (err) {
			Auth.federatedSignIn();
			console.log('checkUser Error: ', err);
			dispatch({ type: 'loaded' });
		}
	}
	async function signOut() {
		try {
		  await Auth.signOut();
		  console.log("Sesión cerrada correctamente.");
		} catch (error) {
		  console.error("Error al cerrar sesión:", error);
		}
	  }

	// NOTIFICATIONS GLOBAL CONTEXT
	// const [notifications, notify]: any = React.useReducer(notificationReducer, initialNotificationsState);

	// function notificationReducer(notifications: Array<NotificationObject>, action: NotificationAction) {
	// 	console.log('notificationReducer action.type: ', action.type);
	// 	switch (action.type) {
	// 		case 'ADD_NOTIFICATION':
	// 			// console.log('ADD_NOTIFICATION action.payload:', action.payload);
	// 			// console.log('ADD_NOTIFICATION notifications:', notifications);
	// 			return [...notifications, ...action.payload];
	// 		// case 'loaded':
	// 		// 	return { ...state, loading: false };
	// 		default:
	// 			return notifications;
	// 	}
	// }

	return (
		<GlobalContext.Provider
			value={{
				userState: userState,
				checkUser: checkUser,
				signOut: signOut,
				session:getSession,

				// notifications: notifications,
				// notify: notify
			}}
		>
			{props.children}
		</GlobalContext.Provider>
	);
};
